export const PURCHASE = 'PURCHASE';
export const PURCHASE_BILL = 'PURCHASE_BILL';
export const PARTNER_PAYOUT_ACCRUAL = 'PARTNER_PAYOUT_ACCRUAL';
export const PAYOUT = 'PAYOUT';
export const REFUND = 'REFUND';

export const TRANSACTION_TYPE_LIST = [
  PURCHASE,
  PURCHASE_BILL,
  PARTNER_PAYOUT_ACCRUAL,
  PAYOUT,
  REFUND,
];

export const TRANSACTION_TYPES_MAP = {
  [PURCHASE]: 'bills.transfers',
  [PURCHASE_BILL]: 'bills.transfers',
  [PARTNER_PAYOUT_ACCRUAL]: 'partners.transfers',
  [PAYOUT]: 'common.payout',
  [REFUND]: 'refund.amount',
};

export const SUCCESS = 'SUCCESS';
export const DECLINE = 'DECLINE';

export const TRANSACTION_STATUS_LIST = [
  SUCCESS,
  DECLINE,
];

export const TRANSACTION_STATUSES_MAP = {
  [SUCCESS]: 'common.successfuls',
  [DECLINE]: 'common.canceled',
};

export const CREATED_AT = 'CREATED_AT';
export const STATUS = 'STATUS';
export const PUBLIC_ID = 'PUBLIC_ID';
export const DESCRIPTION = 'DESCRIPTION';
export const SENDER = 'SENDER';
export const AMOUNT = 'AMOUNT';
export const COMMISSION = 'COMMISSION';
export const CURRENCY = 'CURRENCY';
export const PAYMENT_METHOD = 'PAYMENT_METHOD';

export const TRANSACTION_METRIC_LIST = [
  CREATED_AT,
  STATUS,
  PUBLIC_ID,
  DESCRIPTION,
  SENDER,
  AMOUNT,
  COMMISSION,
  CURRENCY,
  PAYMENT_METHOD,
];

export const TRANSACTION_METRICS_MAP = {
  [CREATED_AT]: 'report.field.created.at',
  [STATUS]: 'report.field.status',
  [PUBLIC_ID]: 'report.field.public.id',
  [DESCRIPTION]: 'report.field.description',
  [SENDER]: 'report.field.sender',
  [AMOUNT]: 'report.field.amount',
  [COMMISSION]: 'report.field.commission',
  [CURRENCY]: 'report.field.currency',
  [PAYMENT_METHOD]: 'report.field.payment.method',
};

export const PROJECT_CODE = 'PROJECT_CODE';
export const COUNT = 'COUNT';
export const RATE = 'RATE';
export const SUM = 'SUM';
export const PARTNER_CURRENCY = 'PARTNER_CURRENCY';

export const PARTNER_METRIC_LIST = [
  PROJECT_CODE,
  COUNT,
  RATE,
  SUM,
  PARTNER_CURRENCY,
];

export const PARTNER_METRICS_MAP = {
  [PROJECT_CODE]: 'report.field.project.code',
  [COUNT]: 'report.field.count',
  [RATE]: 'report.field.rate',
  [SUM]: 'report.field.sum',
  [PARTNER_CURRENCY]: 'report.field.currency',
};
